(() => {
  const banner = () => window.privacyBanner || window.Shopify?.privacyBanner;
  const show = () => {
    const api = banner();
    if (!api?.showPreferences) return false;
    Promise.resolve(api.showPreferences()).catch(() => {
      // The native Shopify anchor remains available if the banner cannot open.
      if (location.hash !== '#shopifyReshowConsentBanner') location.href = '/policies/privacy-policy#shopifyReshowConsentBanner';
    });
    return true;
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href$="#shopifyReshowConsentBanner"]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (show()) event.preventDefault();
  });
  if (location.hash === '#shopifyReshowConsentBanner') {
    let attempts = 0;
    const timer = setInterval(() => {
      if (show() || ++attempts >= 40) clearInterval(timer);
    }, 250);
  }
})();
